import React, {Component}  from 'react';
import {connect}           from 'react-redux';
import {Modal}             from 'react-bootstrap';
import { Link }                from 'react-router-dom';
import FlashRetornoNulo    from '../../../../container/FlashRetornoNulo';
import PalavrasForm        from './desafios_senha_form';
import {SetExcluirPalavra} from '../../../../actions/atividadesAction';
import {ActionModal}       from '../../../../actions/scopoAction';

class SenhaForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal : false,
            load      : false,
            formEdit  : []
        }

        this.open  = this.open.bind(this);
        this.close = this.close.bind(this);

       
    }

    editarPavras(val) {

        this.props.ActionModal(true);

        this.setState({showModal: true, formEdit: this.props.all_palavras[val]});
    }

    close() {
        this.setState({showModal: false, formEdit: []});
    }

    excluirPalavras(pal_id) {
        const acao = window.confirm("Deseja Remover?");
        if (acao) {
            this
                .props
                .SetExcluirPalavra(pal_id);
        }
    }

    open() {
        this.setState({showModal: true});
    }

    componentWillReceiveProps(nextProps){
              
        if(nextProps.actionModal){
            this.setState({showModal: true });
        }else{
            this.setState({showModal: false ,formEdit:[]});
        }
    }

    renderPalavras() {
       
        const lista = this.props.all_palavras;
        const acao  = {width : '10%'}

        if (lista.length !==0) {
            return lista.map((elem, i) => {
                return <tr key={i}>
                    <td className="text-center">{elem.ati_pal_pergunta}</td>
                    <td className="text-center" style={acao}>

                          <Link to={`${this.props.menu.desafios.desafiosenhaaction}/${this.props.pal_id}/${elem.ati_pal_id}`} className="btn btn-warning btn-xs">
                                  <span className="glyphicon glyphicon-pencil"></span>
                            </Link>
                    </td>
                    <td className="text-center" style={acao}>
                        <button
                            className="btn btn-danger btn-xs"
                            onClick={this
                            .excluirPalavras
                            .bind(this, elem.ati_pal_id)}>
                            <span className="glyphicon glyphicon-remove-sign"></span>
                        </button>
                    </td>
                </tr>
            });

        } else {

            return <tr>
                <td colSpan={3} className="text-center"><FlashRetornoNulo/></td>
            </tr>;
        }
    }

    render() {
        return (
            <div>
                <div className="panel panel-azul-claro panel-cinza">
                    <div className="panel-body">
                        <div>
                            <Modal show={this.state.showModal} onHide={this.close.bind(this)} backdrop="static">
                                <PalavrasForm
                                    funcao   = {this.close.bind(this)}
                                    acao     = {false}
                                    pal_id   = {[this.props.que_id]}
                                    formEdit = {this.state.formEdit}
                                    />                                    
                            </Modal>
                            <table className="table table_panel">
                                <thead>
                                    <tr>
                                        <th className="text-center">Pergunta</th>
                                        <th className="text-center">Editar</th>
                                        <th className="text-center">Excluir</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderPalavras()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {

    return {
             menu         : state.configReducer.menu,
             turma        : state.atividadesReducer.turma,
             tipo         : state.atividadesReducer.tipo,
             titulo       : state.atividadesReducer.titulo,
             disciplina   : state.atividadesReducer.disciplina,
             all_palavras : state.atividadesReducer.fetch_all_palavra,
             actionModal  : state.scopoReducer.actionModal
          }
}

export default connect(mapStateToProps, {SetExcluirPalavra,ActionModal})(SenhaForm);



// WEBPACK FOOTER //
// ./src/components/professor/desafios/senha/desafios_senha_list.js